<!-- pgm模板树 -->
<template>
  <div class="PTemplateListTree">
    <!-- 下面的文件树 -->
    <div class="TemplateTreeScroll">
      <div class="draggable_box">
        <div
          class="FileTree"
          v-if="TemplateType == 'list'">
          <!-- 加key区分两个树，不进行复用 -->
          <el-tree
            :props="props"
            :data="TemplateList"
            :key="1"
            @node-expand="UpdateListBind"
            @node-collapse="nodeCollapse"
            node-key="id"
            :default-expanded-keys="expandedKeys"
            empty-text="No Data">
            <div
              class="TreeWrap"
              slot-scope="{ data }"
              >
              <div v-if="!data.noData">
                <div
                  class="folderItem"
                  v-if="!data.directory">
                  <p class="fileTitle" :title="data.templateName">
                    {{ data.name }} {{ data.mediaCount ? " (" + data.mediaCount + ")" : "" }}
                  </p>
                  <div class="folderOperation">
                    <i
                      class="iconfont icon-bianji"
                      @click.stop="changeFolder('edit', data)"></i>
                    <i
                      class="iconfont icon-icon14"
                      @click.stop="changeFolder('delete', data)"></i>
                  </div>
                </div>
                <div
                  class="draggable_item draggableFile"
                  draggable="true"
                  :data-programtemplate="'programtemplate'"
                  :data-device="JSON.stringify(data)"
                  v-else>
                  <p class="fileTitle" :title="data.name">{{ data.name }}</p>
                  <div class="fileOperation" >
                    <div class="IconWrap">
                      <i
                        class="iconfont icon-bianji"
                        @click.stop="changeFile('edit', data)"></i>
                      <i
                        class="iconfont icon-icon14"
                        @click.stop="changeFile('delete', data)"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="noData"
                v-else>
                {{ $t('lang.noData') }}
              </div>
            </div>
          </el-tree>
        </div>
        <div
          class="searchFileTree"
          v-else>
          <el-tree
            :data="TemplateList"
            :props="props"
            :default-expand-all="true"
            :key="2">
            <div
              class="TreeWrap"
              slot-scope="{ node, data }">
              <div>
                <div
                  class="folderItem"
                  v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                </div>
                <div
                  class="draggable_item draggableFile"
                  draggable="true"
                  :data-programtemplate="'programtemplate'"
                  :data-device="JSON.stringify(data)"
                  v-else>
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                  <div class="fileOperation" >
                    <div class="IconWrap">
                      <i
                        class="iconfont icon-bianji"
                        @click.stop="changeFile('edit', data)"></i>
                      <i
                        class="iconfont icon-icon14"
                        @click.stop="changeFile('delete', data)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
export default {
  props: {
    // 模板列表
    TemplateList: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 列表还是搜索
    TemplateType: {
      type: String, // list,search
      default: 'list'
    }
  },
  data () {
    return {
      // 列表配置
      props: {
        label: 'name',
        children: 'floderAndPGMTemplateList',
        isLeaf: 'directory'
      },
      // 展开的节点
      expandedKeys: []
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 对文件夹进行操作
    changeFolder (type, data) {
      this.$emit('EditDelete', {
        directory: false,
        type: type,
        data: data
      })
    },
    // 对文件进行操作
    changeFile (type, data) {
      this.$emit('EditDelete', {
        directory: true,
        type: type,
        data: data
      })
    },
    // 文件夹打开更新列表绑定
    UpdateListBind (item) {
      Bus.$emit('leftListUpdate')
      this.expandedKeys.push(item.id)
    },
    // 关闭节点
    nodeCollapse (item) {
      const index = this.expandedKeys.indexOf(item.id)
      if (index !== -1) {
        this.expandedKeys.splice(index, 1)
      }
    }
  }
}
</script>

<style scoped lang="less" >
.PTemplateListTree {
  i {
    color: #cccccc;
  }
  .TemplateTreeScroll {
    max-height: 325px;
    overflow-y: auto;
  }
  .TemplateTreeScroll::-webkit-scrollbar:horizontal {
    display: none;
  }
  .draggable_box {
    margin-top: 5px;
    ::v-deep .el-tree {
      .el-tree-node__content {
        height: 32px;
        .el-icon-caret-right:before {
          font-size: 16px;
        }
        .el-icon-loading {
          display: none;
        }
      }
      .TreeWrap {
        // width: 90%;
        width: calc(100% - 28px);
        .folderItem,
        .draggable_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 32px;
          position: relative;
          .checkbox{
            position: absolute;
            top: -4px;
            left: 0px;
            transform: translate(-100%);
            margin-left: -5px;
            .checkWrap{
              span{
                display: inline-block;
                width: 17px;
                height: 17px;
                border-radius: 50%;
                background: #38AB52;
                color: #FFFFFF;
                line-height: 17px;
                transform: scale(0.7);
                font-size: 12px;
              }
            }
            .icon-checkbox1{
              color: #38AB52;
            }
            i {
              font-size: 12px;
            }
          }
          .fileTitle {
            width: 60%;
            font-size: 12px;
            color: #cccccc;
            text-align: left;
            overflow: hidden;
            margin: 0;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .folderOperation {
            width: 40%;
            padding-right: 6px;
            text-align: right;
            i {
              font-size: 16px;
              margin-right: 6px;
            }
          }
          .fileOperation {
            width: 40%;
            .IconWrap {
              display: none;
              text-align: right;
              padding-right: 6px;
              i {
                font-size: 16px;
                margin-right: 6px;
              }
            }
          }
        }
        .draggable_item:hover .fileOperation {
          .IconWrap {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          .FileTime {
            display: none;
          }
        }
      }
    }
  }
}
</style>
